import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  LaptopCoffeeWifiIcon,
  LateCheckOutIcon,
  EarlyCheckInIcon,
  HundredDollarIcon,
  RoomUpgradeIcon,
  sanitize,
} from '@americanexpress/consumer-travel-base';
import { IconHotel, IconRewards, IconDining } from '@americanexpress/dls-icons';
import styles from './BenefitCards.scss';

const Benefit = ({ benefitDetails }) => {
  const { id, benefit, icon } = benefitDetails;

  const baseIcons = {
    LaptopCoffeeWifiIcon: <LaptopCoffeeWifiIcon className={styles.benefitIcon} color="white" aria-hidden="true" />,
    LateCheckOutIcon: <LateCheckOutIcon className={styles.benefitIcon} color="white" aria-hidden="true" />,
    EarlyCheckInIcon: <EarlyCheckInIcon className={styles.benefitIcon} color="white" aria-hidden="true" />,
    HundredDollarIcon: <HundredDollarIcon className={styles.benefitIcon} aria-hidden="true" />,
    RoomUpgradeIcon: <RoomUpgradeIcon color="white" className={styles.benefitIcon} aria-hidden="true" />,
    'dls-icon-hotel': <IconHotel color="white" size="lg" aria-hidden="true" />,
    'dls-icon-rewards': <IconRewards color="white" size="lg" aria-hidden="true" />,
    'dls-icon-dining': <IconDining color="white" size="lg" aria-hidden="true" />,
  };

  return (
    <div className={`${styles.padBottomLastChild} pad-1-b flex flex-align-items-center`} id={id}>
      {baseIcons[icon]}
      <span
        className={clsx(styles.textTransform, 'margin-0-b label-1 color-graphic-brand-logo-blue-box-text pad-2-l', styles.textWrapper)}
        /* eslint-disable-next-line react/no-danger -- content from oneCMS */
        dangerouslySetInnerHTML={{ __html: sanitize(benefit, { html: true }) }}
      />
    </div>
  );
};

Benefit.propTypes = {
  benefitDetails: PropTypes.shape({
    id: PropTypes.string,
    benefit: PropTypes.string,
    icon: PropTypes.string,
  }).isRequired,
};

export default Benefit;
